import { type RouteObject } from 'react-router'
import Suppliers from './pages/Suppliers'
import NewSupplier from './pages/NewSupplier'

const supplierRoutes: RouteObject[] = [
  {
    path: 'suppliers',
    element: <Suppliers />
  },
  {
    path: 'suppliers/:supplierId',
    element: <Suppliers />
  },
  {
    path: 'suppliers/create_new',
    element: <NewSupplier />
  }
]

export default supplierRoutes
